import React, { memo } from 'react';
import { useTranslations } from '@hooks/useTranslations';
import { usePrices } from '@hooks/usePriceCalculator';
import { useJourneyType } from '@hooks/useJourneyType';
import { useCarDetailsDuck } from '@hooks/useCarDetailsDuck';
import { useMoneyFormatter } from '@hooks/useMoneyFormatter';
import { useFeatureSwitchEnabled } from '@hooks/useFeatureSwitchEnabled';
import { NON_BREAKING_SPACE } from '../../constants/main';
import { FEATURES_LIST } from '../../context/featureSwitchApp';

export const DepositText = memo(() => {
    const { t } = useTranslations();
    const { formatAmount } = useMoneyFormatter();
    const { isFinance } = useJourneyType();
    const { ecoBonus, isValidForEcoBonus } = useCarDetailsDuck();
    const { finance } = usePrices(null, false, null, true);
    const hasEcobonus = ecoBonus && ecoBonus !== '0';
    const {
        financeProperties: { deposit },
    } = finance;
    const showEcoBonus = useFeatureSwitchEnabled(FEATURES_LIST.FEATURE_SWITCH_SHOW_ECO_BONUS);
    if (!isFinance) {
        return null;
    }

    return (
        <div>
            {t('deposit.finance.label')} <strong>{formatAmount(deposit, false, t('price.pattern.currency'))}</strong>
            {(showEcoBonus || isValidForEcoBonus) && hasEcobonus && (
                <small>
                    <br />
                    {t('deposit.electric&hybrid.label', {
                        ecologicalBonus: formatAmount(ecoBonus, true),
                    }).replace(' ', NON_BREAKING_SPACE)}
                </small>
            )}
        </div>
    );
});
DepositText.displayName = 'DepositText';
